import styled from '@emotion/styled';
import { COLORS } from '../../../../../constants/radar';

export const FormContainer = styled.div`
  flex: 1;
  background: white;
  overflow-y: auto;
  padding: 8px 24px 0 24px;
`;

export const ResultCount = styled.div`
  color: #64748B;
  font-size: 14px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    font-weight: 600;
  }
`;
